import { get } from "lodash";
import { AuthenticatedDataType } from "../lib/types/types";

const isUserLoggedIn = (): boolean => {
	return localStorage.getItem("token") ? true : false;
};
const getLocalstorageToken = (): AuthenticatedDataType | null => {
	let tokenEncoded = localStorage.getItem("token");

	if (tokenEncoded) {
		let tokenObj = JSON.parse(atob(tokenEncoded));
		return tokenObj;
	} else {
		return null;
	}
};
const getUserJwt = (): string => {
	let tokenObj = getLocalstorageToken();
	return tokenObj !== null ? get(tokenObj, "jwt", "") : "";
};

export { isUserLoggedIn, getUserJwt, getLocalstorageToken };
